import styled from "styled-components";

export const FooterWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  bottom: 0;
`;

export const StyledLink = styled.a`
  text-decoration: none;
  color: black;
  padding: 0;
  margin: 0;
  text-align: center;
`;
